module.exports = __webpack_public_path__ + "img/sii.9c85d2a1.svg";